module.exports = __webpack_public_path__ + "img/derby-promotions.a5dd03e6.png";